import { defineMessages } from "react-intl";

export const messages = defineMessages({
    home: {
        id: "ui.pages.home",
        defaultMessage: "Home",
    },
    datesDay: {
        id: "ui.dates.day",
        defaultMessage: "Day",
    },
    datesMonth: {
        id: "ui.dates.month",
        defaultMessage: "Month",
    },
    datesYear: {
        id: "ui.dates.year",
        defaultMessage: "Year",
    },
    datesStart: {
        id: "ui.dates.start",
        defaultMessage: "Start Date",
    },
    datesEnd: {
        id: "ui.dates.end",
        defaultMessage: "End Date",
    },
    loading: {
        id: "ui.async.loading",
        defaultMessage: "Loading",
    },
    loadMore: {
        id: "ui.async.load-more",
        defaultMessage: "Load more",
    },
    buttonCreate: {
        id: "ui.button.create",
        defaultMessage: "Create",
    },
    buttonEdit: {
        id: "ui.button.edit",
        defaultMessage: "Edit",
    },
    buttonUpdate: {
        id: "ui.button.update",
        defaultMessage: "Update",
    },
    buttonDelete: {
        id: "ui.button.delete",
        defaultMessage: "Delete",
    },
    buttonDownload: {
        id: "ui.button.download",
        defaultMessage: "Download",
    },
    buttonDownloadCsv: {
        id: "ui.button.download-csv",
        defaultMessage: "Download CSV",
    },
    buttonYes: {
        id: "ui.button.yes",
        defaultMessage: "Yes",
    },
    buttonNo: {
        id: "ui.button.no",
        defaultMessage: "No",
    },
    buttonShowMore: {
        id: "ui.button.show-more",
        defaultMessage: "Show more",
    },
    buttonShowFewer: {
        id: "ui.button.show-fewer",
        defaultMessage: "Show fewer",
    },
    selectAddLabel: {
        id: "ui.select.add_label",
        defaultMessage: "Add \"{label}\"?",
    },
    selectClearAll: {
        id: "ui.select.clear_all",
        defaultMessage: "Clear all",
    },
    selectClearValue: {
        id: "ui.select.clear_value",
        defaultMessage: "Clear value",
    },
    selectNoResults: {
        id: "ui.select.no_results",
        defaultMessage: "No results found",
    },
    selectPlaceholderLabel: {
        id: "ui.select.placeholder",
        defaultMessage: "Select...",
    },
    selectSearchPrompt: {
        id: "ui.select.search_prompt",
        defaultMessage: "Type to search",
    },
    selectLoading: {
        id: "ui.select.loading",
        defaultMessage: "Loading...",
    },
    createEntity: {
        id: "ui.phrases.create_entity",
        defaultMessage: "Create {entity}",
    },
    editEntity: {
        id: "ui.phrases.edit_entity",
        defaultMessage: "Edit {entity}",
    },
    deleteEntity: {
        id: "ui.phrase.delete_entity",
        defaultMessage: "Delete {entity}",
    },
    deleteEntityLong: {
        id: "ui.phrase.delete_entity_long",
        defaultMessage: "Are you sure you want to delete {entity}, \"{name}\"?",
    },
    tableManage: {
        id: "table.manage",
        defaultMessage: "Manage",
    },
    filter: {
        id: "table.filter",
        defaultMessage: "Filter",
    },
    resetFilters: {
        id: "table.reset-filters",
        defaultMessage: "Reset filters",
    },
    filterPlaceholder: {
        id: "table.filter-placeholder",
        defaultMessage: "Start typing to filter...",
    },
});
